import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';
import TransportComponent from './TransportComponent';
import CUALtaxiPanel from './CUALtaxiPanel';

const TransportModule = ({ user }) => {
  const [status, setStatus] = useState(null);
  const [view, setView] = useState('transport'); // transport | cualtaxi
  const [activating, setActivating] = useState(false);

  useEffect(() => {
    axios.get(`${API}/cualtaxi/status`).then(r => setStatus(r.data)).catch(() => setStatus({ active: false }));
  }, []);

  const activate = async () => {
    if (!window.confirm('¿Activar el modo profesional CUALtaxi? Esto te dara acceso a herramientas de gestion de vehiculo, gastos, mantenimiento, repuestos y metricas.')) return;
    setActivating(true);
    try {
      await axios.post(`${API}/cualtaxi/activate`);
      const r = await axios.get(`${API}/cualtaxi/status`);
      setStatus(r.data);
      setView('cualtaxi');
    } catch (e) {
      alert(e.response?.data?.detail || 'Error activando CUALtaxi');
    } finally {
      setActivating(false);
    }
  };

  if (view === 'cualtaxi' && status?.active) {
    return <CUALtaxiPanel user={user} onExit={() => setView('transport')} />;
  }

  return (
    <div className="space-y-4" data-testid="transport-module">
      {/* Banner CUALtaxi */}
      <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-2xl p-5 text-white shadow-lg" data-testid="cualtaxi-banner">
        {status?.active ? (
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-wide text-white/80">Modo profesional activo</p>
              <h3 className="text-xl font-bold flex items-center gap-2">🚖 CUALtaxi</h3>
              <p className="text-sm text-white/90">Accede a tu suite de gestion profesional</p>
            </div>
            <button
              onClick={() => setView('cualtaxi')}
              data-testid="open-cualtaxi-btn"
              className="px-4 py-2 bg-white text-orange-700 rounded-lg font-semibold text-sm hover:bg-white/90"
            >
              Abrir CUALtaxi →
            </button>
          </div>
        ) : (
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-wide text-white/80">¿Eres taxista?</p>
              <h3 className="text-xl font-bold flex items-center gap-2">🚖 Activa CUALtaxi</h3>
              <p className="text-sm text-white/90">Lleva control de tu vehiculo, gastos, mantenimiento y rentabilidad como un profesional.</p>
            </div>
            <button
              onClick={activate}
              disabled={activating}
              data-testid="activate-cualtaxi-btn"
              className="px-4 py-2 bg-white text-orange-700 rounded-lg font-semibold text-sm hover:bg-white/90 disabled:opacity-50 whitespace-nowrap"
            >
              {activating ? 'Activando...' : 'Activar CUALtaxi'}
            </button>
          </div>
        )}
      </div>

      {/* Modulo Transporte normal */}
      <TransportComponent user={user} />
    </div>
  );
};

export default TransportModule;
